import http from "./http-common";

class ProcedureService {
  getIconImage(el) {
    if (el.Settings && el.Settings.Property && el.Settings.Property.mimetype && el.Settings.Property.mimetype != null) {
      return this.getIconFromMimetype(el.Settings.Property.mimetype);
    }
    else if (el.Url != null)
      return this.getIconFromMimetype(el.Url);
    return null;
  }
  getIconFromMimetype(mimetype) {
    var url = "/images/file_icons/";
    if (mimetype.indexOf("pdf") > 0)
      url += "pdf.png";
    else if (mimetype.indexOf("ppt") > 0)
      url += "ppt.png";
    else if (mimetype.indexOf("officedocument.presentationml.presentation") > 0)
      url += "ppt.png";
    else if (mimetype.indexOf("png") > 0)
      url += "png.png";
    else if (mimetype.indexOf("gif") > 0)
      url += "gif.png";
    else if (mimetype.indexOf("mp3") > 0)
      url += "mp3.png";
    else if (mimetype.indexOf("mp4") > 0)
      url += "mp4.png";
    else if (mimetype.indexOf("jpg") > 0)
      url += "jpg.png";
    else if (mimetype.indexOf("jpeg") > 0)
      url += "jpg.png";
    else if (mimetype.indexOf("gif") > 0)
      url += "gif.png";
    else if (mimetype.indexOf("avi") > 0)
      url += "avi.png";
    else if (mimetype.indexOf("zip") > 0)
      url += "zip.png";
    else
      url = null;
    return url;
  }
}

export default new ProcedureService();



// WEBPACK FOOTER //
// ./src/components/services/ProcedureService.js